export const examples_data = {
    "corvus": [
        "Find the maximum quantity for every sku, also output the sum of quantities except the maximum one for that sku.",
        "Find the maximum quantity for every sku, also output the sum of quantities except the maximum one and add another column if this sum is less than the maximum quantity.",
        "Group the SKUs that moved locations into three clusters based on frequency of moves, say less than 50 slow, >= 50 and <60 medium, and >=60 fast.",
        "Give me the maximum quantity of every sku.",
        "Show the oldest instance of every sku."
    ],
    "easyeat": [
        "How many orders got completed in Januray 2023?",
        "Give me the best-selling item along with quantity for every restaurant in January 2023.",
        "What is the total GMV in January 2023?",
        "Which all restaurants completed orders on Easy Eat in January 2023?",
        "What were the total sales for every restaurant in January 2023?",
        "How many customers visited more than once for every restaurant in January 2023?"
    ],
    "frikedia": [
        "Virat Kohli average in ODIs."
    ],
    "ecommerce": [
        "What is the monthly trend of orders?",
        "Give me the GMV for 2022.",
        "Give me GMV by region for 2022.",
        "What is the total revenue lost due to failed payments?",
        "What is the total sales by region?"
    ]
}